module.exports = __webpack_public_path__ + "static/img/company_logo.bb3ac64b.png";